// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_redotech-arbiter-lib-badge-redo-badge-arbiter-badge-container";
export var circle = "_redotech-arbiter-lib-badge-redo-badge-circle";
export var colorSwatch = "_redotech-arbiter-lib-badge-redo-badge-color-swatch";
export var compactSwatch = "_redotech-arbiter-lib-badge-redo-badge-compact-swatch";
export var fillWidth = "_redotech-arbiter-lib-badge-redo-badge-fill-width";
export var iconButton = "_redotech-arbiter-lib-badge-redo-badge-icon-button";
export var iconWrapper = "_redotech-arbiter-lib-badge-redo-badge-icon-wrapper";
export var shadow = "_redotech-arbiter-lib-badge-redo-badge-shadow";
export var xs = "_redotech-arbiter-lib-badge-redo-badge-xs";